"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _noop2 = _interopRequireDefault(require("lodash-es/noop"));

var _context = require("../../context");

var _radioComponents = require("./_radio-components");

var _radioContent = require("./_radio-content");

var _versions = require("../../_utils/versions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Radio = function Radio(props) {
  var checked = props.checked,
      version = props.version,
      type = props.type,
      layout = props.layout,
      onClick = props.onClick,
      onKeyUp = props.onKeyUp,
      spaceBetween = props.spaceBetween,
      noSpace = props.noSpace;
  var propsToPass = {
    checked: checked,
    version: version,
    type: type,
    layout: layout,
    onClick: onClick,
    onKeyUp: onKeyUp,
    spaceBetween: spaceBetween,
    noSpace: noSpace
  };

  if (props.type === 'button' || props.type === 'badge') {
    return _react["default"].createElement(_radioComponents.StyledRadioButton, propsToPass, (0, _radioContent.getRadioContent)(props, true));
  }

  return _react["default"].createElement(_radioComponents.StyledRadioButton, {
    onClick: onClick,
    onKeyUp: onKeyUp,
    layout: layout,
    type: type,
    spaceBetween: spaceBetween,
    noSpace: noSpace
  }, (0, _radioContent.getRadioContent)(props, false));
};

var Radios =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Radios, _React$Component);

  function Radios(props) {
    var _this;

    _classCallCheck(this, Radios);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Radios).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "toggleRadio", function (evt, changeToValue) {
      evt.preventDefault();
      if (_this.props.readOnly) return;
      var selectedRadioValue = _this.state.selectedRadio ? _this.state.selectedRadio.props.value : null;
      /* only change if it is not aleady selected */

      if (selectedRadioValue !== changeToValue) {
        _react["default"].Children.map(_this.props.children, function (child) {
          if (child.props.value === changeToValue && !child.props.readOnly) {
            _this.setState({
              selectedRadio: child
            });

            _this.props.onChange(changeToValue);
          }
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "keyUpHandler", function (evt, value) {
      if (evt.which === 13) {
        _this.toggleRadio(evt, value);
      }
    });

    var valuesLabels = _react["default"].Children.map(props.children, function (child) {
      return _objectSpread({}, child.props);
    }); // let selectedRadio = props.children[0] || props.children


    var selectedRadio;

    _react["default"].Children.map(props.children, function (child) {
      if (child.props.checked) selectedRadio = child;
    });

    _this.state = {
      valuesLabels: valuesLabels,
      selectedRadio: selectedRadio
    };
    return _this;
  }

  _createClass(Radios, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var selectedRadioValue = this.state.selectedRadio ? this.state.selectedRadio.props.value : null;
      return _react["default"].createElement(_radioComponents.RadiosNavigation, {
        layout: this.props.layout,
        "native": this.props["native"]
      }, this.state.valuesLabels.map(function (_ref) {
        var value = _ref.value,
            label = _ref.label,
            icon = _ref.icon,
            text = _ref.text,
            error = _ref.error,
            warning = _ref.warning,
            success = _ref.success,
            activeColor = _ref.activeColor,
            activeBorderColor = _ref.activeBorderColor,
            activeTextColor = _ref.activeTextColor,
            tooltip = _ref.tooltip,
            customKey = _ref.customKey;
        return _react["default"].createElement(Radio, {
          key: customKey || value,
          value: value,
          label: label,
          icon: icon,
          layout: _this2.props.layout,
          readOnly: _this2.props.readOnly,
          checked: value === selectedRadioValue,
          onClick: function onClick(evt) {
            return _this2.toggleRadio(evt, value);
          },
          onKeyUp: function onKeyUp(evt) {
            return _this2.keyUpHandler(evt, value);
          },
          version: _this2.props.version,
          shadowOnHover: (0, _versions.getProperties)(_this2.props, 'radio').shadowOnHover,
          type: _this2.props.type,
          text: text,
          error: error,
          warning: warning,
          success: success,
          activeColor: activeColor,
          activeTextColor: activeTextColor,
          tooltip: tooltip,
          activeBorderColor: activeBorderColor,
          noSpace: _this2.props.noSpace,
          spaceBetween: _this2.props.spaceBetween
        });
      }));
    }
  }]);

  return Radios;
}(_react["default"].Component);

Radios.Radio = function (props) {
  return _react["default"].createElement(Radio, props);
};

Radios.RadiosNavigation = _radioComponents.RadiosNavigation;
Radios.propTypes = {
  /** Specify Layout */
  layout: _propTypes["default"].oneOf(['horizontal', 'vertical']),

  /** Function called on change */
  onChange: _propTypes["default"].func,

  /** Disable flag */
  readOnly: _propTypes["default"].bool,
  noSpace: _propTypes["default"].bool,

  /** No margins */
  "native": _propTypes["default"].bool,
  spaceBetween: _propTypes["default"].string,
  type: _propTypes["default"].oneOf(['default', 'button']),
  tooltip: _propTypes["default"].shape({
    /** Content to show in the tooltip */
    content: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element]).isRequired,

    /** Where to place the tooltip */
    position: _propTypes["default"].oneOf(['top', 'bottom']),

    /** How to align the tooltip */
    align: _propTypes["default"].oneOf(['left', 'middle', 'right']),

    /** How to align the content within the  tooltip */
    textAlign: _propTypes["default"].oneOf(['left', 'center', 'right'])
  })
};
Radios.defaultProps = {
  onChange: _noop2["default"],
  layout: 'horizontal',
  readOnly: false,
  type: 'default',
  noSpace: false
};
Radios.displayName = 'Radios';

var _default = (0, _context.withVersion)(Radios);

exports["default"] = _default;